export default __webpack_public_path__ + "static/media/mobiletwo.cb44da40.png";